<template>
  <div class="animated fadeIn upload-prk">
    <b-card v-if="!showUploadFrm">
      <div slot="header">
        Hasil Import Data Kolektor
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="saveimportdata()">
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-primary mr-1" @click="cancel()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <b-card no-body>
        <template v-slot:header v-if="(filterShow=='Hide')">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="rekonsil">Rekon Status</b-form-checkbox>
                  <b-form-checkbox value="uraian1">Description Sub Modul</b-form-checkbox>
                  <b-form-checkbox value="uraian2">Description GL</b-form-checkbox>
                  <b-form-checkbox value="nilai1">Value Sub Modul</b-form-checkbox>
                  <b-form-checkbox value="nilai2">Value GL</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0 text-nowrap"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="rptLines"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
                  <template v-slot:cell(nomor)="data">{{ data.index +1}}</template>
        </b-table>
        <b-row class="mt-2">
          <b-col lg="10">
            <b-row>
              <b-col cols="2">
                <!-- <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                  class="ml-2"
                >
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox> -->
              </b-col>
              <b-col cols="10">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
                    <span
                      class="mr-1"
                    >limit per page :</span>
                    <select v-model="tblLcy.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                  <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <!-- <b-col lg="2">
            <b-row align-h="right">
              <b-col md="12">
                <b-form-group label="Total Nilai Jaminan">
                  <my-number
                    class="form-control text-right"
                    v-model="subtotal.totalGl"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col> -->
        </b-row>
      </b-card>
    </b-card>
    <b-row align-h="center" v-else>
      <b-col md="10">
        <b-card>
          <div slot="header">
            Import Data Kolektor
            <div class="card-header-actions">
              <div>
                <b-button class="btn-normal alert mb-2 mr-2" @click="close">
                  <i class="fa fa-times"></i> Close
                </b-button>
              </div>
            </div>
          </div>

          <b-card class="ColsDefine">
            <strong>Difinisi nama Kolom Excel untuk setiap Fileld pada data Kolektor</strong>
            <b-row class="mt-2">
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>N.I.Kepegawaian</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.crewnik" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No KTP</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.ktp" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Nama Kolektor</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.crewname" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Jenis Kelamin</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.crewmale" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tgl. Lahir</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.crewdob" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Email</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.crewmail" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No Hp</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.crewhp" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="4">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Alamat</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.crewaddr" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kota</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.crewcity" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kode Pos</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.crewpost" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
              </b-col>
            </b-row>
          </b-card>
          <b-row>
            <b-col lg="8">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Choose *.XLSX file</label>
                </b-input-group-prepend>
                <b-form-file
                  v-model="fileXlsx"
                  :state="Boolean(fileXlsx)"
                  placeholder="Choose a XLSX file..."
                  drop-placeholder="Drop XLSX file here..."
                ></b-form-file>
              </b-input-group>
            </b-col>
            <!-- <b-col lg="4">
              <button class="btn btn-primary mr-1" @click="exportxls()">
                <i class="fa fa-file-excel-o"></i> Download contoh file import
              </button>
            </b-col> -->
          </b-row>

          <b-row no-gutters>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Nama SHEET</label>
                </b-input-group-prepend>
                <b-form-input v-model="frmUpload.sheetName" :state="!$v.frmUpload.sheetName.$error"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-append>
                  <label class="input-group-text ml-1">Data mulai baris ke-</label>
                </b-input-group-append>
                <b-form-input
                  v-model="frmUpload.startRow"
                  type="number"
                  :state="!$v.frmUpload.startRow.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <div slot="footer" class="text-center">
            <b-button variant="primary" @click="importdata()">Import</b-button>
            <b-button variant="danger" @click="close()">Cancel</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.upload-prk {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import moment from "moment";
// import arreport from "../../apis/arreport";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();
import kolektorkredit from "../../apis/kolektorkredit";
export default {
  mixins: [validationMixin],
  validations: {
    frmUpload: {
      sheetName: { required },
      startRow: { required },
      namajaminan: { required },
      pemilikjaminan: { required },
      hubungandgnpemilik: { required },
      tipejaminan: { required },
      alamat: { required },
      bpkb: { required },
      stnk: { required },
      sertifikatno: { required },
      sertifikatstatus: { required },
      invoiceno: { required },
      statusasuransi: { required },
      nilaijaminan: { required },
    },
    model: {
      tgl1: { required },
      tgl2: { required },
    },
  },
  data() {
    return {
      showUploadFrm: true,
      fileXlsx: null,
      frmUpload: {
        sheetName: "KOLEKTOR_LIST",
        startRow: 9,
        crewnik: "B",
        ktp: "C",
        crewname: "D",
        crewmale: "E",
        crewdob: "F",
        crewmail: "G",
        crewhp: "H",
        crewaddr: "I",
        crewcity: "J",
        crewpost: "K",
      },
      kolomXls: [
        "",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "AA",
        "AB",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AH",
        "AI",
        "AJ",
        "AK",
        "AL",
        "AM",
        "AN",
        "AO",
        "AP",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
        "AV",
        "AW",
        "AX",
        "AY",
        "AZ",
      ],

      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      model: { account: "", tgl1: "", tgl2: "" },
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      rptLines: [],
      subtotal: {},
      filterShow: "Show",
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "crewnik",
            label: "NIK",
            thClass: "text-center",
            sortable: true,
          },
          {
            key: "crewname",
            label: "Nama Kolektor",
            thClass: "text-center",
            sortable: true,
          },
           {
            key: "crewmale",
            label: "Jenis Kelamin",
            thClass: "text-center",
            sortable: true,
          },
          {
            key: "crewdob",
            label: "Tgl Lahir",
            thClass: "text-center",
            sortable: true,
          },
          {
            key: "crewmail",
            label: "Email",
            thClass: "text-center",
            sortable: true,
          },
          {
            key: "crewhp",
            label: "Ho. HP",
            thClass: "text-center",
            sortable: true,
          },
          {
            key: "crewaddr",
            label: "Alamat",
            thClass: "text-center",
            sortable: true,
          },
          {
            key: "crewcity",
            label: "Kota",
            thClass: "text-center",
            sortable: true,
          },
          {
            key: "crewpost",
            label: "Kode Pos",
            thClass: "text-center",
            sortable: true,
          },

          // {
          //   key: "action",
          //   label: "Action",
          //   thStyle: "width:100px",
          //   thClass: "text-center",
          // },
        ],
      },
      filter: null,
      filterOn: [],
    };
  },
  components: { Loading, myNumber },
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    account() {
      return this.model.account;
    },
  },
  watch: {
    account: function (newval) {
      const obj = this.accounts.find((d) => d.value === newval);
      this.model.namaacc = obj.text || "";
      this.model.kodeacc = obj.kodeacc;
      // console.log(`${this.model.account} | ${this.model.namaacc}`);
    },
  },
  // created: async function(){
  // },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    async importdata() {
      this.isLoading = true;
      try {
        const dt = await kolektorkredit.importdtxls(
          this.fileXlsx,
          this.frmUpload
        );
        this.rptLines = dt;
        this.isLoading = false;
        this.showUploadFrm = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    async saveimportdata() {
      if (this.rptLines.length==0) {
        toastr.warn("Data is empty");
      } else {
         try {
          await kolektorkredit.savebulk(this.rptLines);
          this.showUploadFrm = true;
          toastr.success('Data berhasil diimport');
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    exportxls: async function () {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          const response = await arreport.rekondbexport(this.model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    cancel(){
      this.rptLines=[];
      this.showUploadFrm = true;
    },
    close() {
      //router.push("home");
      router.go(-1);
    },
  },
};
</script>
